import { Router } from "@solidjs/router";
import { FileRoutes } from "@solidjs/start/router";
import { ErrorBoundary, Suspense } from "solid-js";
import { DottedLoader } from "./widgets/loader";
import "./app.css";
import "phosphor-icons/src/css/icons.css";
import { ModalProvider } from "~/components/modal";
import { HubbleError } from "~/components/error";
import { MetaProvider } from "@solidjs/meta";
import { isServer } from "solid-js/web";
import "solid-devtools";
import { captureErrorInSentry } from "~/utils/third_party/sentry";
import { config } from "~/data/config";
import { Toaster } from "solid-toast";
import { HttpHeader } from "@solidjs/start";
import { GoogleAnalytics } from "./utils/third_party/google_analytics";
import { AnalyticsServiceProvider } from "./context/analytics_service_context";
import HubbleAnalyticsService from "./services/analytics_service/hubble_analytics_service";
import { VersionUpdateMessage } from "./components/global/version_update_message";
import { TelescopeProvider } from "./telescope";

export default function HubbleRouter() {
  // initVersionCheck();

  const analyticsService = new HubbleAnalyticsService({});

  return (
    <Router
      root={(props) => (
        <>
          <ErrorBoundary
            fallback={(err) => {
              if (!isServer) {
                captureErrorInSentry(err);
              }

              if (config.env !== "Prod") {
                console.trace(err);
              }

              // Check if this is a deployment error
              // this is a temporary fix to show the version update message
              // when the user is navigating after a new deployment
              const isFreshDeploymentError = err.message
                ?.toLowerCase()
                .includes("failed to fetch dynamically imported module");

              if (isFreshDeploymentError) {
                return <VersionUpdateMessage />;
              }

              return <HubbleError errorMessage={err.message} />;
            }}
          >
            <AnalyticsServiceProvider analyticsService={analyticsService}>
              <TelescopeProvider
              // theme="telescope-dark-theme"
              >
                <ModalProvider>
                  <MetaProvider>
                    <SecurityHeaders />
                    <GoogleAnalytics />
                    <Suspense fallback={<DottedLoader from="app.tsx" />}>
                      {props.children}
                      {/* <VersionUpdateModal /> */}
                    </Suspense>
                  </MetaProvider>
                  <Toaster position="top-center" />
                </ModalProvider>
              </TelescopeProvider>
            </AnalyticsServiceProvider>
          </ErrorBoundary>
        </>
      )}
    >
      <FileRoutes />
    </Router>
  );
}

function SecurityHeaders() {
  return (
    <>
      {/* any domains for allowing iframes should be whitelisted in below header (csp) */}
      <HttpHeader
        name="Content-Security-Policy"
        value="frame-ancestors 'self' https://web.getvisitapp.net https://vouchers.myhubble.money https://vouchers.dev.myhubble.money http://localhost:* https://hubble-sdk-git-fix-rewards-portal-deep-link-b4a76d-hubble-money.vercel.app"
      />

      <HttpHeader name="X-Content-Type-Options" value="nosniff" />
    </>
  );
}
